import React from 'react';
import { motion } from 'framer-motion';
import ResumePreview from './ResumePreview';

const templates = [
  {
    id: 'modern',
    name: 'Modern',
    description: 'Clean lines and contemporary styling',
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Traditional corporate aesthetic',
  },
  {
    id: 'creative',
    name: 'Creative',
    description: 'Stand out with unique design',
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Simple elegance and clarity',
  }
];

const Templates = () => {
  return (
    <section id="templates" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Professional Templates
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Choose from expertly designed templates that make candidates shine
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {templates.map((template, index) => (
            <motion.div
              key={template.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="relative w-full aspect-[210/297] rounded-lg overflow-hidden shadow-md border border-slate-200 group-hover:shadow-xl group-hover:border-indigo-200 transition-all duration-300 bg-white">
                <div className="absolute top-0 left-0 w-[280%] h-[280%] origin-top-left scale-[0.357] pointer-events-none">
                  <ResumePreview template={template.id} viewOnly={true} />
                </div>
              </div>
              <div className="mt-3 text-center">
                <h3 className="text-base font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors">
                  {template.name}
                </h3>
                <p className="text-xs text-slate-500 mt-0.5">
                  {template.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Templates;